import React, {useEffect, useRef} from 'react';
import './index.css';

interface P {
	unit: any
	label: string
	position: any
	value: string
	onChange: any
	onBlur: any
	tabIndex: number
	hasError: boolean
	isFlashing: boolean
	inputMode?: 'none' | 'text' | 'tel' | 'url' | 'email' | 'numeric' | 'decimal' | 'search';
}

export default ({unit, label, position, value, onChange, onBlur, tabIndex, hasError, isFlashing, inputMode = 'text'}: P) => {
	const inputRef = useRef<any>(null); // Ref to access the input element
	const spanRef = useRef<any>(null); // Ref to access the temporary span element

	// Function to update the input width
	const updateInputWidth = () => {
		if (spanRef.current && inputRef.current) {
			// Set the span's text content to match the input value
			spanRef.current.textContent = value;

			// Measure the width of the span and set the input width accordingly
			const width = spanRef.current.offsetWidth;
			inputRef.current.style.width = `${width + 10}px`; // Add some padding
		}
	};

	// Update the input width whenever the value changes
	useEffect(() => {
		updateInputWidth();
	}, [value]);

	return (
		<span className={`cr-input-holder ${hasError ? 'input-err' : isFlashing ? 'flashing-field' : ''}`} style={position} >
  			<span className={`cr-input-label`}>{label}</span>
			<span className={`hidden-span`} ref={spanRef}></span>
			<input
				ref={inputRef}
				value={value}
				onChange={onChange}
				onBlur={onBlur}
				className={`custom-roof-input`}
				tabIndex={tabIndex || 0}
				inputMode={inputMode}
			/>
  			<span className={`unit`}>{unit}</span>
		</span>

	);
}